import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";
import SvgViewer from "bracket-system/svg-viewer";
import useBracketViewport from "common/hooks/bracketViewportHook";

const useStyles = makeStyles((theme) => ({
    surface: {
        border: `2px solid ${Colors.panel}`,
        borderRadius: theme.shape.borderRadius,
        overflow: "hidden",
        // without this a drag starting inside a match selects text instead of panning
        userSelect: "none",
        // takes whatever height the page has left, so the buttons below stay visible
        flex: "1 1 0px",
        minHeight: 200,
    },
    spaced: {
        marginTop: theme.spacing() * 3,
        marginBottom: theme.spacing() * 3,
    },
}));

export function useBracketSurface({ spaced } = {}) {
    const ref = React.useRef();
    const styles = useStyles();
    const { width, height, ready } = useBracketViewport(ref);

    // memoized so a re-render doesn't remount the viewer and reset its pan/zoom
    const svgWrapper = React.useCallback(
        ({ children, ...props }) => (
            <SvgViewer width={width} height={height} {...props}>
                {children}
            </SvgViewer>
        ),
        [width, height]
    );

    return {
        ready,
        width,
        svgWrapper,
        surfaceProps: {
            ref,
            className: spaced
                ? `${styles.surface} ${styles.spaced}`
                : styles.surface,
        },
    };
}

/** Row of pick actions under the bracket, matched to the surface width. */
export function BracketActionRow({ width, children }) {
    return (
        <div
            style={{
                width,
                display: "flex",
                justifyContent: "center",
                marginBottom: 10,
            }}
        >
            {children}
        </div>
    );
}
